export function roundFloat(input, prec) {
  return parseFloat(input.toFixed(prec));
}
export function isString(value) {
  return Object.prototype.toString.call(value).replace(/^\[object (.+)\]$/, '$1').toLowerCase() === 'string';
}
export function getScrollTop(elem) {
  return elem && typeof elem.scrollTop === 'number' ? elem.scrollTop : window.pageYOffset || 0;
}
export function convertToCss(str) {
  var re = /[A-Z]/g;
  return str.replace(re, function ($1) {
    return "-".concat($1.toLowerCase());
  });
}